import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { url } from './_utils/url';


@Injectable({
  providedIn: 'root'
})
export class MunicipioService{


  constructor(private http: HttpClient) {}

  getUf():Observable<any>{
    return this.http.get<any>(url.consulta.municipiosUf.get_uf)
  }

  getMunicipios(uf:any):Observable<any>{
    return this.http.get<any>(url.consulta.municipiosUf.get_municipios + uf + '/municipios')
  }
}
